import { useState, useEffect } from "react";
import { Breadcrumb, Table } from "antd";
import Loader from "../../components/loader/loader";
import { addIcon, editIcon, redTrash } from "../../assets";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import { useNavigate } from "react-router-dom";
import { GreenNotify } from "../../helper/helper";

const Preference = () => {
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [preference, setpreference] = useState([]);
  const [getServiceapi, setGetServiceApi] = useState(false);

  const getAllPreferences = () => {
    let getRes = (res) => {
      setpreference(res?.data?.data);
    };

    callApi(
      "GET",
      routes.getAllPreferences,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      },
    );
  };

  const deletePreference = (id) => {
    setGetServiceApi(false);
    let getRes = (res) => {
      console.log("res of deleteQuote", res);
      GreenNotify("Quote is deleted successfully");
      setGetServiceApi(true);
    };

    callApi(
      "DELETE",
      `${routes.deletePreference}/${id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      },
    );
  };

  useEffect(() => {
    getAllPreferences();
  }, [getServiceapi]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      className: "role-name-column-header",
    },
    {
      title: "Type",
      dataIndex: "type",
      align: "center",
      className: "type-name-column-header",
    },
    {
      title: "News categories",
      dataIndex: "newsCategories",
      align: "center",
      className: "news-categories-column-header",
    },
    {
      title: "Edit",
      dataIndex: "edit",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Delete",
      dataIndex: "delete",
      align: "center",
      className: "action-column-header",
    },
  ];

  const data = preference?.map((item, index) => {
    return {
      key: index,
      title: item?.title,
      type: item?.type,
      newsCategories: item?.newsCategories?.length
        ? item.newsCategories.join(", ")
        : "—",
      edit: (
        <div
          onClick={() => navigate("/editpreference", { state: { item: item } })}
          style={{ cursor: "pointer" }}
        >
          <img src={editIcon} alt="editIcon" />
        </div>
      ),
      delete: (
        <div
          onClick={() => deletePreference(item?._id)}
          style={{ cursor: "pointer" }}
        >
          <img src={redTrash} alt="red-trash" />
        </div>
      ),
    };
  });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />

      <Breadcrumb
        separator=">"
        className="bread-crumb"
        items={[
          {
            title: "Home",
          },
          {
            title: "Preference",
          },
        ]}
      />

      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "2rem",
        }}
      >
        <h1>Preference</h1>
        <div
          onClick={() => navigate("/newpreference")}
          style={{
            padding: "8px 16px",
            display: "flex",
            alignItems: " center",
            justifyContent: "center",
            borderRadius: "8px",
            background: "#0C3C9E",
            cursor: "pointer",
            gap: 10,
          }}
        >
          <img src={addIcon} alt="" />
          <p style={{ color: "white" }}>Add New Preference</p>
        </div>
      </div>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={{ pageSize: 5 }}
          className="subscriptionapi-table"
        ></Table>
      </div>
    </div>
  );
};

export default Preference;
